import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { fetcher } from '~lib/api/fetch';

import QueryKeys from '../queryKeys';

export interface IKeywordTag {
  id: number;
  name: string;
  imageUrl: string;
  interest: 'CAREER' | 'COMPANY';
}

export interface ITagObj {
  career: IKeywordTag[];
  company: IKeywordTag[];
}

export function useOnboardingTagsQuery() {
  return useQuery<IKeywordTag[], AxiosError, ITagObj>(
    [QueryKeys.onboardingTag],
    () => fetcher('/api/user/onboarding/tags'),
    {
      select: (data) => ({
        career: data.filter((item) => item.interest === 'CAREER'),
        company: data.filter((item) => item.interest === 'COMPANY'),
      }),
    },
  );
}
